import { ALTERAR_DETALHAMENTO_FECHAMENTO_CAIXA, BUSCAR_FECHAMENTOS_CAIXA, LIMPAR_FECHAMENTOS_CAIXA } from '../../actions/types'

const initialState = undefined

export default function reducerBuscarFechamentosCaixa (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_FECHAMENTOS_CAIXA: {
      if (action.payload.data) {
        const fechamentos = action.payload.data.fechamentos.map(fechamento => Object.assign({}, fechamento, { exibirDetalhe: false }));
        return {
          ...state,
          fechamentos,
          total: action.payload.data.total
        }
      }
      return state
    }

    case ALTERAR_DETALHAMENTO_FECHAMENTO_CAIXA: {
      const { fechamento } = action.payload;
      const detalhamento = action.payload.response ? action.payload.response.data : null;
      const indice = state.fechamentos.indexOf(fechamento);
      const nova = Object.assign({}, fechamento, { exibirConteudo: !fechamento.exibirConteudo });
      const fechamentos = [...state.fechamentos];
      fechamentos[indice] = nova;

      if (detalhamento) {
        fechamentos[indice].detalhamento = detalhamento;
      }


      return { ...state, fechamentos };
    }

    case LIMPAR_FECHAMENTOS_CAIXA:
      return []

    default: {
      return state
    }
  }
}
